(() => {
  if (customElements.get('dp-department-form')) return;
  customElements.define('dp-department-form', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const status = this.querySelector('[data-dept-status]');
      if (status && location.search.includes('contact_posted')) status.focus();
      this.select = this.querySelector('[data-dept-select]');
      this.copies = new Map([...this.querySelectorAll('[data-dept-copy]')].map(el => [el.dataset.deptCopy, el.dataset]));
      this.service = this.dataset.defaultService;
      if (!this.querySelector('textarea[name="contact[body]"]')) return;
      const params = new URL(location.href).searchParams;
      if (this.select) {
        this.select.disabled = false;
        const requested = params.get('dp_service') || params.get('inquiry');
        if (!this.querySelector('[data-dept-errors]') && this.copies.has(requested)) this.select.value = requested;
        this.service = this.select.value;
        this.select.addEventListener('change', () => { this.service = this.select.value; this.update(); }, { signal: this.controller.signal });
        document.addEventListener('click', event => {
          const link = event.target.closest('a[data-dp-service]');
          if (!link || !this.copies.has(link.dataset.dpService)) return;
          const target = new URL(link.href, location.href);
          if (target.pathname !== location.pathname || target.hash !== '#DPProjectForm') return;
          this.select.value = link.dataset.dpService;
          this.service = this.select.value;
          this.update();
        }, { signal: this.controller.signal });
      }
      if (!this.querySelector('[data-dept-errors]') && this.service === 'moving') {
        const requestedPacking = params.get('dp_packing');
        const packing = this.querySelector('select[name="contact[Packing assistance]"]');
        if (packing && ['no_packing', 'packing_scope_unsure'].includes(requestedPacking)) {
          const option = [...packing.options].find(item => item.dataset.option === requestedPacking);
          if (option) {
            packing.value = option.value;
            const context = this.querySelector('[data-packing-context]');
            if (context) context.hidden = false;
          }
        }
      }
      this.packing = this.querySelector('select[name="contact[Packing assistance]"]');
      this.packing?.addEventListener('change', () => this.updateScope(), { signal: this.controller.signal });
      this.update();
      this.querySelector('[data-dept-source]').value = location.origin + location.pathname;
    }
    update() {
      const copy = this.copies.get(this.service);
      if (!copy) return;
      this.querySelectorAll('[data-dept-services]').forEach(group => {
        const active = group.dataset.deptServices.split(' ').includes(this.service);
        group.hidden = !active;
        group.disabled = !active;
      });
      this.querySelector('[data-dept-department]').value = copy.department;
      this.querySelector('[data-dept-message-label]').textContent = copy.message;
      this.querySelector('[data-dept-hint]').textContent = copy.hint;
      this.querySelector('[data-dept-submit]').textContent = copy.submit;
      this.updateScope();
    }
    updateScope() {
      const summary = this.querySelector('[data-moving-summary]');
      if (!summary || !['moving', 'signature'].includes(this.service)) return;
      const packing = this.packing?.selectedOptions[0]?.dataset.option;
      let level = this.service === 'signature' ? 'signature' : 'undecided';
      if (this.service === 'moving') {
        if (packing === 'no_packing') level = 'moving';
        else if (['full_packing', 'partial_packing', 'packing_scope_unsure'].includes(packing)) level = 'packing';
      }
      const copy = this.querySelector('[data-moving-scope-copy="' + level + '"]')?.dataset;
      if (!copy) return;
      summary.querySelector('[data-moving-title]').textContent = copy.title;
      summary.querySelector('[data-moving-scope-text]').textContent = copy.scope;
      summary.querySelector('[data-moving-service-field]').value = copy.title;
      summary.querySelector('[data-moving-scope-field]').value = copy.scope;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
